import React from 'react';
import { Sparkles, Check } from 'lucide-react';

export const ORANGE = '#EA4A1F';
export const SELENA_AVATAR = 'https://static.prod-images.emergentagent.com/jobs/21451e29-cab5-4e90-871e-ca1e5024c78f/images/1073d102d7339614af2f5a3956dc9571b0f8497b0179e3f4c74b20019b6ff33e.jpeg';

export const Eyebrow = ({ children, testid }) => (
  <span
    data-testid={testid}
    className="inline-flex items-center gap-1.5 rounded-full border border-[#EA4A1F]/30 bg-[#FFF1EB] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-[#EA4A1F]"
  >
    <Sparkles className="h-3 w-3" /> {children}
  </span>
);

export const CheckList = ({ items }) => (
  <ul className="mt-8 space-y-4">
    {items.map((t) => (
      <li key={t} className="flex items-start gap-3 text-[15px] leading-snug text-stone-800">
        <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#EA4A1F] text-white">
          <Check className="h-3 w-3" strokeWidth={3} />
        </span>
        {t}
      </li>
    ))}
  </ul>
);

export const MockFrame = ({ children, className = '' }) => (
  <div className={`rounded-[28px] border border-stone-200/80 bg-white p-6 shadow-[0_30px_80px_-30px_rgba(234,74,31,0.25)] ${className}`}>
    {children}
  </div>
);

export const SplitSection = ({ id, eyebrow, title, accent, text, bullets, mock, reverse, testid }) => (
  <section id={id} data-testid={testid} className="relative px-4 py-20 sm:px-6 md:py-28">
    <div className={`mx-auto grid max-w-6xl items-center gap-14 lg:grid-cols-2 ${reverse ? 'lg:[&>*:first-child]:order-2' : ''}`}>
      <div>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 className="mt-6 text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
          <span className="text-stone-950">{title}</span>
          <br />
          <span className="text-[#EA4A1F]">{accent}</span>
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-stone-600 md:text-lg">{text}</p>
        <CheckList items={bullets} />
      </div>
      <div className="transition-transform duration-500 hover:-translate-y-1">{mock}</div>
    </div>
  </section>
);
